import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessengerService } from './messenger.service';

@Injectable({
  providedIn: 'root'
})
export class MemberConsentService implements OnDestroy
{
  public memberConsentStatus = [
    { key: 'MEMBER-CONSENT-STATUS-PENDING', value: 'PENDING', ordinalValue: 0, text: 'Pending' },
    { key: 'MEMBER-CONSENT-STATUS-DECLINED', value: 'DECLINED', ordinalValue: 1, text: 'Declined' },
  ];
  
  private messagingLanguageChangedSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private messengerService: MessengerService)
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  public getMemberConsentStatusText(memberConsentStatus: string): string
  {
    let text = memberConsentStatus;
    const aValue = this.memberConsentStatus.find(x => x.value === memberConsentStatus);
    if (aValue !== undefined)
    {
      text = aValue.text;
    }
    return text;
  }

  /**
   * Load localizations
   */
  private loadLocalizations(): void
  {
    const stagesTranslationKeys = this.memberConsentStatus.map(a => a.key);
    this.translate.get(stagesTranslationKeys).subscribe({
      next: (res: string) =>
      {
        for (let i = 0; i < this.memberConsentStatus.length; i++)
        {
          const key = 'MEMBER-CONSENT-STATUS-' + this.memberConsentStatus[i].value.replace(/_/g, '-');
          this.memberConsentStatus[i].text = res[key];
        }
      }
    });
  }
}
